module.exports = __webpack_public_path__ + "static/media/soham_parekh.c80f036c.jpg";